import { Vertical } from "./enums";
import VerticalOption from "./Verticals/Vertical";
import React from "react";

interface displayVerticalsProps {
    setFieldIsEmpty: (isEmpty: boolean) => void;
    chosenVertical: string;
    updateVerticalChoice: () => void;
}

const DisplayVerticals = ({setFieldIsEmpty, chosenVertical, updateVerticalChoice}: displayVerticalsProps) => {
    return (
        <div>
            {Object.entries(Vertical).map(([verticalId, vertical]) => (
                <div key={verticalId}>
                    <VerticalOption vertical={vertical} verticalId={verticalId} setFieldIsEmpty={setFieldIsEmpty} chosenVertical={chosenVertical} updateVerticalChoice={updateVerticalChoice}/>
                </div>
            ))}
        </div>
    )
}
export default DisplayVerticals;